export const Base_Date_Format_Options = [{
  label: '年/月/日 时分',
  // 显示名称
  value: 'YYYY/MM/DD HH:mm',
  // 存在prop的dateFormat
  formula: 'min',
  // ???
  module: 'min',
  // 最小的单位
  range: 'date',
  // antd picker
  pickerShowTime: true,
  // antd picker showtime
  dayjsStartOf: 'minute',
  // 在筛选时 除了筛选范围start
  dayjsEndOf: 'minute',
  conditionFilterFormat: 'YYYY/MM/DD HH:mm' // 筛选时显示的formula
}, {
  label: '年-月-日 时分',
  value: 'YYYY-MM-DD HH:mm',
  formula: 'MIN_DASHED',
  module: 'min',
  range: 'date',
  pickerShowTime: true,
  dayjsStartOf: 'minute',
  dayjsEndOf: 'minute',
  conditionFilterFormat: 'YYYY-MM-DD HH:mm'
}, {
  label: '年月日时分',
  value: 'YYYYMMDDHHmm',
  formula: 'MIN',
  module: 'min',
  range: 'date',
  pickerShowTime: true,
  dayjsStartOf: 'minute',
  dayjsEndOf: 'minute',
  conditionFilterFormat: 'YYYY/MM/DD HH:mm'
}, {
  label: '年/月/日 上午/下午',
  value: 'YYYY/MM/DD A',
  formula: 'min',
  module: 'meridiem',
  range: 'date',
  dayjsStartOf: 'date',
  dayjsEndOf: 'date',
  conditionFilterFormat: 'YYYY/MM/DD A'
}, {
  label: '年-月-日 上午/下午',
  value: 'YYYY-MM-DD A',
  formula: 'MIN_DASHED',
  module: 'meridiem',
  range: 'date',
  dayjsStartOf: 'date',
  dayjsEndOf: 'date',
  conditionFilterFormat: 'YYYY-MM-DD A'
}, {
  label: '年/月/日',
  value: 'YYYY/MM/DD',
  formula: 'day',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY/MM/DD'
}, {
  label: '年月日',
  value: 'YYYYMMDD',
  formula: 'DAY',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY/MM/DD'
}, {
  label: '年-月-日',
  value: 'YYYY-MM-DD',
  formula: 'DAY_DASHED',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY-MM-DD'
}, {
  label: '日/月/年',
  value: 'DD/MM/YYYY',
  formula: 'DAY_SLASH_REVERSE',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'DD/MM/YYYY'
}, {
  label: '年月',
  value: 'YYYYMM',
  formula: 'YEAR_MONTH',
  module: 'month',
  range: 'month',
  dayjsStartOf: 'month',
  dayjsEndOf: 'month',
  conditionFilterFormat: 'YYYY/MM'
}, {
  label: '年/月',
  value: 'YYYY/MM',
  formula: 'mon',
  module: 'month',
  range: 'month',
  dayjsStartOf: 'month',
  dayjsEndOf: 'month',
  conditionFilterFormat: 'YYYY/MM'
}, {
  label: '年-月',
  value: 'YYYY-MM',
  formula: 'YEAR_MONTH_DASHED',
  module: 'month',
  range: 'month',
  dayjsStartOf: 'month',
  dayjsEndOf: 'month',
  conditionFilterFormat: 'YYYY-MM'
}, {
  label: '月/日',
  value: 'MM/DD',
  formula: 'MON_DAY_SLASH',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY/MM/DD'
}, {
  label: '月-日',
  value: 'MM-DD',
  formula: 'MON_DAY_DASHED',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY-MM-DD'
}, {
  label: '月日',
  value: 'MMDD',
  formula: 'MON_DAY',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY/MM/DD'
}, {
  label: '年',
  value: 'YYYY',
  formula: 'year',
  module: 'year',
  range: 'year',
  dayjsUnit: 'date',
  dayjsStartOf: 'year',
  dayjsEndOf: 'year',
  conditionFilterFormat: 'YYYY'
}, {
  label: '年（农历）',
  value: 'YYYY',
  formula: 'lunar_year',
  module: 'year',
  range: 'year',
  dayjsUnit: 'date',
  dayjsStartOf: 'year',
  dayjsEndOf: 'year',
  conditionFilterFormat: 'YYYY',
  onlyFormula: true
}, {
  label: '月',
  value: 'MM',
  formula: 'MON',
  module: 'month',
  range: 'month',
  dayjsStartOf: 'month',
  dayjsEndOf: 'month',
  conditionFilterFormat: 'YYYY/MM'
}, {
  label: '日',
  value: 'DD',
  formula: 'MONTH_DAY',
  module: 'day',
  range: 'date',
  dayjsStartOf: 'day',
  dayjsEndOf: 'day',
  conditionFilterFormat: 'YYYY/MM/DD'
}, {
  label: '时分',
  value: 'HH:mm',
  formula: 'time',
  module: 'time',
  range: 'time',
  dayjsStartOf: 'minute',
  dayjsEndOf: 'minute',
  conditionFilterFormat: 'YYYY/MM/DD HH:mm'
}];
export const Date_Format_Options = Base_Date_Format_Options.filter(i => {
  if ('onlyFormula' in i) {
    return !i.onlyFormula;
  }
  return true;
});
export const DATE_INTERVAL_OPTIONS = [{
  label: '天',
  value: 'day'
}, {
  label: '小时',
  value: 'hour'
}, {
  label: '分钟',
  value: 'min'
}];

// 日期自动更新的范围快捷选择项
export const AUTO_UPDATE_RANGE_OPTIONS = [{
  label: '当天',
  value: 0
}, {
  label: '近3天',
  value: 2
}, {
  label: '近7天',
  value: 7
}, {
  label: '近14天',
  value: 13
}, {
  label: '近30天',
  value: 29
}];